import { createContext, type Dispatch, type MutableRefObject, type SetStateAction } from 'react'

export type SearchAction = 'next' | 'refresh' | null

export const SearchContext = createContext<{
  searchAction: SearchAction
  searchEdgeIndex: number
  searchEdgeRef: MutableRefObject<{ index: number; userId?: string } | undefined>
  setSearchAction: Dispatch<SetStateAction<SearchAction>>
  setSearchEdgeIndex: Dispatch<SetStateAction<number>>
}>({
  searchAction: null,
  searchEdgeIndex: 0,
  searchEdgeRef: { current: undefined },
  setSearchAction: () => {},
  setSearchEdgeIndex: () => {}
})
